const ValueSpan = ({ value }) => <span>{value}</span>;
export default ValueSpan;